export enum Agrupamento {
    HORA = 'HORA',
    DIA = 'DIA'
}